import { render } from "./StudentListCard.vue?vue&type=template&id=10250c85"
import script from "./StudentListCard.vue?vue&type=script&lang=js"
export * from "./StudentListCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__